import { render, staticRenderFns } from "./Prodotti.vue?vue&type=template&id=14f6dbb8&scoped=true"
import script from "./Prodotti.vue?vue&type=script&lang=js"
export * from "./Prodotti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f6dbb8",
  null
  
)

export default component.exports